module.exports = "<svg id=\"6b4e3a9a-0e50-408d-8917-f254015144d9\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1280 1280\"><title>Triangle</title><path d=\"M461,640.1V928.2l4.3-2.5c19.5-11.4,414.4-239.2,449.4-259.3,33.9-19.4,44.8-26.2,44-27S884.4,596,795,544.5l-246-142c-45.9-26.5-84.5-48.7-85.7-49.4l-2.3-1.2Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Triangle.svg
// module id = RTsH
// module chunks = 1